// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caption-text {
    font-size: 14px;
    color: #1E293B;
    font-family: "Inter", "Public Sans", "Roboto", "Helvetica", "Arial", sans-serif;
}

.css-1qbdd0n,
.css-1nos2st,
.css-1bmbtuq {
    padding: 5px !important
}

a {
    cursor: pointer
}

.form-group {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.custom-datepicker {
    width: 100%;
    padding: 10px;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    font-family: "Inter", "Public Sans", "Roboto", "Helvetica", "Arial", sans-serif;
}

.custom-datepicker:focus {
    outline: none;
    border-color: #4D7CFE;
    box-shadow: 0 0 0 3px rgba(77, 124, 254, 0.16);
}

.datePicker {
    display: flex;
    align-items: center;
}

.transparent-background {
    background-image:
        linear-gradient(45deg, #e0e0e0 25%, transparent 25%),
        linear-gradient(-45deg, #e0e0e0 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #e0e0e0 75%),
        linear-gradient(-45deg, transparent 75%, #e0e0e0 75%);
    background-size: 20px 20px;
    /* Kích thước của các ô vuông */
    background-position: 0 0, 10px 0, 10px -10px, 0px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.transparent-background img {
    max-width: 100%;
    max-height: 100%;
}

.css-1dur2uz-MuiPaper-root-MuiDialog-paper{
    max-width: 800px!important;
}

.css-mb472d-MuiPaper-root-MuiDialog-paper{
    max-width: 100vw!important;
    min-width: 70vw!important;
}

.css-wsbsjb-MuiFormControlLabel-root{
    margin: 0!important;
}
.css-1cohrqd-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{
  height: 50px!important;
}
  .google-sheets-table {
          width: 100%;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
          font-size: 12px;
          color: black!important;
        }
        .google-sheets-table th, .google-sheets-table td {
          border: 1px solid #d0d0d0;
          padding-left: 6px;
          padding-right: 6px;
          text-align: right;
        }
        .google-sheets-table thead th {
          background-color: #f1f3f4;
          font-weight: bold;
          /* color: #333; */
        }
        .google-sheets-table tbody td {
          background-color: #fff;
        }
        .google-sheets-table tbody tr:nth-child(even) td {
          background-color: #f9f9f9;
        }
        .google-sheets-table tbody tr:hover td {
          background-color: #e8f0fe;
        }
        .google-sheets-table th[colspan="5"] {
          text-align: center;
          background-color: #e8eaed;
        }
        .sticky-col { /* For Safari */
          position: sticky;
          left: 0;
          background-color: #fff;
          z-index: 1;
          border-right: 1px solid #d0d0d0; /* Optional: Adds a border to the right */
        }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,+EAA+E;AACnF;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,+EAA+E;AACnF;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;;;;6DAIyD;IACzD,0BAA0B;IAC1B,+BAA+B;IAC/B,sDAAsD;IACtD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;AACA;EACE,sBAAsB;AACxB;EACE;UACQ,WAAW;UACX,yBAAyB;UACzB,8BAA8B;UAC9B,eAAe;UACf,sBAAsB;QACxB;QACA;UACE,yBAAyB;UACzB,iBAAiB;UACjB,kBAAkB;UAClB,iBAAiB;QACnB;QACA;UACE,yBAAyB;UACzB,iBAAiB;UACjB,iBAAiB;QACnB;QACA;UACE,sBAAsB;QACxB;QACA;UACE,yBAAyB;QAC3B;QACA;UACE,yBAAyB;QAC3B;QACA;UACE,kBAAkB;UAClB,yBAAyB;QAC3B;QACA,cAC4B,eAAe;UACzC,gBAAgB;UAChB,OAAO;UACP,sBAAsB;UACtB,UAAU;UACV,+BAA+B,EAAE,yCAAyC;QAC5E","sourcesContent":[".caption-text {\n    font-size: 14px;\n    color: #1E293B;\n    font-family: \"Inter\", \"Public Sans\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\n.css-1qbdd0n,\n.css-1nos2st,\n.css-1bmbtuq {\n    padding: 5px !important\n}\n\na {\n    cursor: pointer\n}\n\n.form-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.custom-datepicker {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #E2E8F0;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    font-family: \"Inter\", \"Public Sans\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\n.custom-datepicker:focus {\n    outline: none;\n    border-color: #4D7CFE;\n    box-shadow: 0 0 0 3px rgba(77, 124, 254, 0.16);\n}\n\n.datePicker {\n    display: flex;\n    align-items: center;\n}\n\n.transparent-background {\n    background-image:\n        linear-gradient(45deg, #e0e0e0 25%, transparent 25%),\n        linear-gradient(-45deg, #e0e0e0 25%, transparent 25%),\n        linear-gradient(45deg, transparent 75%, #e0e0e0 75%),\n        linear-gradient(-45deg, transparent 75%, #e0e0e0 75%);\n    background-size: 20px 20px;\n    /* Kích thước của các ô vuông */\n    background-position: 0 0, 10px 0, 10px -10px, 0px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.transparent-background img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.css-1dur2uz-MuiPaper-root-MuiDialog-paper{\n    max-width: 800px!important;\n}\n\n.css-mb472d-MuiPaper-root-MuiDialog-paper{\n    max-width: 100vw!important;\n    min-width: 70vw!important;\n}\n\n.css-wsbsjb-MuiFormControlLabel-root{\n    margin: 0!important;\n}\n.css-1cohrqd-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{\n  height: 50px!important;\n}\n  .google-sheets-table {\n          width: 100%;\n          border-collapse: collapse;\n          font-family: Arial, sans-serif;\n          font-size: 12px;\n          color: black!important;\n        }\n        .google-sheets-table th, .google-sheets-table td {\n          border: 1px solid #d0d0d0;\n          padding-left: 6px;\n          padding-right: 6px;\n          text-align: right;\n        }\n        .google-sheets-table thead th {\n          background-color: #f1f3f4;\n          font-weight: bold;\n          /* color: #333; */\n        }\n        .google-sheets-table tbody td {\n          background-color: #fff;\n        }\n        .google-sheets-table tbody tr:nth-child(even) td {\n          background-color: #f9f9f9;\n        }\n        .google-sheets-table tbody tr:hover td {\n          background-color: #e8f0fe;\n        }\n        .google-sheets-table th[colspan=\"5\"] {\n          text-align: center;\n          background-color: #e8eaed;\n        }\n        .sticky-col {\n          position: -webkit-sticky; /* For Safari */\n          position: sticky;\n          left: 0;\n          background-color: #fff;\n          z-index: 1;\n          border-right: 1px solid #d0d0d0; /* Optional: Adds a border to the right */\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
